import React, { useRef } from 'react'
import TalentAppStep from "../components/TalentAppStep";
import { FormInputComponent } from "../../../components/form/Form";
import { Checkbox, Divider, InputNumber, Radio } from "antd";
import ReactDOM from "react-dom";
import { CommitmentOptions } from "../../talent-preferences/components/DashboardPreferences";


export default class AvailabilityStatusStep extends TalentAppStep {
    static path = '/work-status';
    static LastUpdatedMethod = 'lastUpdatedWorkStatus';

    /**
     * The title shown on the form
     */
    // static StepTitle = TB.trans('talent.recommended_skills.step_title');
    static StepTitle = 'Work Status';
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = 'Please let us know your current work status and job preferences.';

    /**
     * The start page info tile
     */
    static StepInfo = 'Work Status';

    /**
     * Show or hide review step info
     */
    static HideReview = true
    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Work Preferences';

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        // return false;
        // user.validateDisciplineSkills()
        return user.validateAvailabilityStatus()
    };

    static hasCompleted(user) {
        return user.validateAvailabilityStatus();
    }

    /**
     * The step needed before editing
     */
    static StepNeedsValidation(user) {
        if (!user.validateAvailabilityStatus()) {
            return this;
        }

        return false;
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            isLoading: true
        }
    }

    /**
     * Handles mapping
     *
     * @param params
     * @returns {Object}
     */
    mapping(params) {
        return params?.talentPreferences?.() || params
    }

    async onChange(params) {

        let result = {};
        for (let [key, value] of Object.entries(params)) {
            result = TB.set(result, key, value);
        }

        let allTimeZones = Object.values({ ...laravel.talent_questions.time_zones });
        if (result.prefers_any_timezone !== this.props.user.prefers_any_timezone) {
            if (result.prefers_any_timezone) {
                for (let timeZone of allTimeZones) {
                    result.selected_time_zones[timeZone.id] = true;
                }
            } else {
                result.selected_time_zones = {}
            }
            result.prefers_any_non_us_timezone = result.prefers_any_timezone;
        }
        TB.map(TB.TimeZonesNotInUS(), zone => {
            result.selected_time_zones[zone.value] = result.prefers_any_non_us_timezone;
        })
        let timeZones = []
        TB.map(result.selected_time_zones, (selected, timeZoneId) => {
            if (selected) {
                timeZones.push(parseInt(timeZoneId));
            }
        })
        result.time_zones = timeZones;
        console.log(' resutlttttt',TB.pick(result, ['time_zones', 'selected_time_zones']));
        return super.onChange({ ...result });

    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {
        return [
            {
                style: styles.fieldSection,
                fields: {
                    sections: (
                        <AvailabilityStatusFields {...this.props} />
                    )
                }
            }
        ]
    };

    // /**
    //  * Render the form
    //  *
    //  * @returns {Form}
    //  */
    // render() {
    //     return (
    //         <div className="talent-application px-4 md:px-8 xl:w-10/12 w-full mr-auto ml-0">
    //             {this.renderTitle()}
    //
    //             <div className="px-8 py-6 talent-preferences-panel mt-0">
    //                 <PreferenceQuestionnaire
    //                     {...this.props}
    //                     disabled={this.props.disabled}
    //                     preferences={this.props.user.talentPreferences()}
    //                     onChange={(props) => this.onChange(props)}
    //                 />
    //             </div>
    //
    //             {this.renderFormFooter()}
    //         </div>
    //     );
    // }

    // renderFormFooter() {
    //
    //     if (this.props.user.isTalentSupplierResource()) {
    //         return null;
    //     }
    //     return (
    //         <div>
    //             <div className="talent-role-form mt-8">
    //                 <Form
    //                     ref={this.nestedFormRefs?.[0]}
    //                     title={null}
    //                     subtitle={null}
    //                     showRequired
    //                     submitButton={false}
    //                     onChange={(model) => {
    //                         let updates = {};
    //
    //                         TB.map(model, (value, key) => {
    //                             updates = TB.set(updates, key, value);
    //                         })
    //                         console.log('onChangePrefs', updates)
    //                         this.props.onChange(updates)
    //                     }}
    //                     model={{...this.props.user}}
    //                     fields={[]}
    //
    //                     isDisabled={this.props.disabled}>
    //
    //
    //                 </Form>
    //
    //             </div>
    //         </div>
    //     )
    // }


}

const AvailabilityStatusFields = (props) => {
    const formRef = useRef();
    // const initialPreferences = { ...props.preferences };
    // const preferences = props.preferences;
    // const [preferences, setPreferences] = useState(initialPreferences);

    const invalidFields = () => {
        if (!formRef.current) {
            return false
        }
        let invalid = formRef.current.forceValidate();
        if (invalid) {
            const node = ReactDOM.findDOMNode(invalid);
            $('html, body').animate({ scrollTop: $(node).offset().top }, 1000);
        }
        return invalid;
    }
    let preferences = props.user.talentPreferences?.() || {};

    return (
        <React.Fragment>
            <div style={{ flexBasis: '100%' }}>
                <h5 className="form-header">WORK STATUS</h5>
                {/*<p className="form-subheader">*/}
                {/*    */}
                {/*</p>*/}
            </div>
            {props.user.isOnTalentMarketplace() && (
                <div className="field-section">
                    <div className="field px-4">
                        <FormInputComponent
                            fieldName="is_available"
                            value={props.user.is_available}
                            label="Profile Visibility"
                            type="antd-input"
                            required={false}
                        >
                            <Radio.Group
                                className="flex gap-2 items-center"
                                defaultValue={props.user.is_available}
                            >
                                <Radio value={true}>Yes</Radio>
                                <Radio value={false}>No</Radio>
                                <p className="text-sm ml-4 whitespace-no-wrap mb-2.5">
                                    My profile <strong>{props.user.is_available ? 'WILL' : 'WILL NOT'}</strong> show
                                    up on the Wripple platform
                                </p>
                            </Radio.Group>
                        </FormInputComponent>
                    </div>
                </div>
            )}
            <div className="field-section">
                <div className="field px-4">

                    <FormInputComponent
                        value={props.user.talent_commitment_level}
                        fieldName="talent_commitment_level"
                        label="Describe your current work status"
                        type="antd-input"
                    >
                        <Radio.Group
                            className="flex gap-4"
                            name="talent_commitment_level"
                        >
                            {Object.keys(CommitmentOptions).map(key => {
                                return (
                                    <Radio value={Number(key)} className="whitespace-normal">
                                        <span className="flex flex-col items-start gap-1">
                                            <span className="text-sm font-medium">
                                                {CommitmentOptions[key].title}
                                            </span>
                                            <span className="text-xxs">
                                                {CommitmentOptions[key].description}
                                            </span>
                                        </span>
                                    </Radio>
                                )
                            })}
                        </Radio.Group>
                    </FormInputComponent>
                </div>
            </div>
            <div className="field-section">
                <div className="field px-4">
                    <FormInputComponent
                        value={props.user.has_full_time_employment_interest}
                        fieldName="has_full_time_employment_interest"
                        label="Would you be interested in a permanent employment opportunity?"
                        type="antd-input"
                        required
                        className="field [&_.invalid-feedback]:relative"
                    >
                        <Radio.Group defaultValue={props.user.has_full_time_employment_interest}>
                            <Radio value={true}>Yes</Radio>
                            <Radio value={false}>No</Radio>
                        </Radio.Group>
                    </FormInputComponent>
                </div>
            </div>


            <Divider className="mt-0" />
            <div style={{ flexBasis: '100%' }} className="inline">
                <h5 className="form-header">Scheduling & Logistics</h5>
                {/*<p className="form-subheader">*/}
                {/*    */}
                {/*</p>*/}
            </div>
            <div className="field-section">
                <div className="field px-4">
                    <FormInputComponent
                        value={props.user.available_hours_per_week}
                        fieldName="available_hours_per_week"
                        label="Hours per week typically available for freelancing?"
                        type="antd-input"
                        max={40}
                        pattern={/^\b([1-9]|[1-3][0-9]|40)\b/}
                        min={1}
                        className="field [&_.invalid-feedback]:relative"
                        validation={{
                            rules: {
                                isInt: true,
                                matchRegexp: /^\b([1-9]|[1-3][0-9]|40)\b/,
                            },
                            errors: {
                                matchRegexp: "The number of hours must be between 1 and 40",
                                isInt: TB.trans('validation.numeric', {
                                    'attribute': 'available hours per week'
                                }),
                            }
                        }}
                    >

                        <InputNumber
                            controls={false}
                            className="max-w-48"
                            addonAfter=" hours per week "
                            required={true} />

                    </FormInputComponent>

                </div>
            </div>
            <div className="field-section">
                <div className="field px-4">
                    <div className="form-group flex flex-col items-stretch">
                        <label className="col-form-label">
                            Time zones I will work in:
                        </label>
                        <div
                            className="pl-3 form-group flex flex-row flex-wrap justify-start items-start max-w-[550px]">
                            {TB.map(TB.TimeZonesInUS(), (zone) => {
                                if (zone.is_in_us) {
                                    return (
                                        <div className="basis-1/3" key={zone.id}>
                                            <FormInputComponent
                                                value={preferences.prefers_any_timezone ? true : preferences.selected_time_zones?.[parseInt(zone.id)]}
                                                fieldName={`selected_time_zones[${zone.id}]`}
                                                disabled={preferences.prefers_any_timezone}
                                                type='antd-input'
                                                className="mb-0"
                                                label={false}
                                                required={false}
                                            >
                                                <Checkbox
                                                    value={undefined}
                                                    checked={preferences.prefers_any_timezone ? true : preferences.selected_time_zones?.[parseInt(zone.id)]}>
                                                    <span className="text-xs">
                                                        {zone.name}
                                                    </span>
                                                </Checkbox>

                                            </FormInputComponent>
                                        </div>
                                    )
                                }
                                return null
                            })}
                            <div className="basis-1/3">

                                <FormInputComponent
                                    value={preferences.prefers_any_non_us_timezone}
                                    disabled={preferences.prefers_any_timezone}
                                    fieldName="prefers_any_non_us_timezone"
                                    type='antd-input'
                                    className="mb-0"
                                    label={false}
                                    required={false}
                                >
                                    <Checkbox
                                        value={undefined}
                                        checked={preferences.prefers_any_non_us_timezone}>
                                        <span className="text-xs">
                                            Global (excluding U.S.)
                                        </span>
                                    </Checkbox>

                                </FormInputComponent>
                            </div>
                        </div>
                        <hr className="pl-3 mb-2 mt-0" />

                        <div className="flex pl-3 flex-row items-center">
                            <div className="basis-1/2">
                                <FormInputComponent
                                    value={props.user.prefers_any_timezone}
                                    fieldName="prefers_any_timezone"
                                    type='antd-input'
                                    className="mb-0"
                                    label={false}
                                    required={false}
                                >
                                    <Checkbox
                                        value={undefined}
                                        checked={props.user.prefers_any_timezone}>
                                        <span className="text-xs">
                                            All of the above
                                        </span>
                                    </Checkbox>

                                </FormInputComponent>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            {!props.user.isTalentSupplierResource() && (
                <React.Fragment>
                    <div className="field-section">
                        <div className="field px-4">
                            <FormInputComponent
                                label={TB.trans('talent.project_interests.can_travel_for_work_label')}
                                fieldName={`can_travel_for_work`}
                                value={props.user.can_travel_for_work}
                                validationErrors={{
                                    isDefaultRequiredValue: 'Your response is required'
                                }}
                                labelClassName="whitespace-normal"
                                type="antd-input"
                                required={true}
                                columns={10}
                            >
                                <Radio.Group defaultValue={props.user.can_travel_for_work}>
                                    <Radio value={true}>Yes</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>

                            </FormInputComponent>
                        </div>
                    </div>

                    {!!props.user.can_travel_for_work && (
                        <div className="flex flex-row field-section mb-3">
                            <div className="field px-4 basis-2/5 w-2/5">
                                <FormInputComponent
                                    label={TB.trans('talent.project_interests.travel_days_per_week_label')}
                                    type="select"
                                    fieldName={`travel_days_per_week`}
                                    required={props.user.can_travel_for_work}
                                    disabled={!props.user.can_travel_for_work}
                                    value={props.user.travel_days_per_week}
                                    options={[
                                        {
                                            label: 'Select',
                                            value: '',
                                            disabled: true
                                        }
                                    ].concat(TB.range(1, 6)
                                        .map(day => {
                                            return {
                                                label: String(day),
                                                value: day
                                            };
                                        })
                                    )}
                                />
                            </div>

                            <div className="field px-4 basis-2/5 w-2/5">
                                <FormInputComponent
                                    label={TB.trans('talent.project_interests.max_travel_distance_label')}
                                    type="number"
                                    validationErrors={{
                                        isDefaultRequiredValue: 'This field is required',
                                        isInt: 'Must be an integer',
                                    }}
                                    disabled={!props.user.can_travel_for_work}
                                    max={2000}
                                    required={props.user.can_travel_for_work}
                                    fieldName={`max_travel_distance`}
                                    value={props.user.max_travel_distance}
                                    placeholder="Enter distance"
                                />
                            </div>

                            <div className="field px-4 basis-1/5 w-1/5">
                                <FormInputComponent
                                    label="Distance Units"
                                    placeholder="Select Unit"
                                    type="select"
                                    disabled={!props.user.can_travel_for_work}
                                    fieldName={`max_travel_distance_units`}
                                    value={props.user.max_travel_distance_units}
                                    required={props.user.can_travel_for_work}
                                    options={{
                                        Miles: 'Miles',
                                        Kilometers: 'Kilometers',
                                    }}
                                />
                            </div>
                        </div>
                    )}

                </React.Fragment>
            )}
        </React.Fragment>
    )
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    }
    ,
    field: {
        padding: '0 15px',
    },
};